import React from "react";
import "./MovieGrid.css";
import MovieCard from "./MovieCard";
import Icon from "./Icon";

const SKELETON_COUNT = 8;

export default function MovieGrid({ movies, selectedMovieId, onSelect, loading = false }) {
  return (
    <section className="content-panel glass-panel">
      <div className="section-heading movie-grid-heading">
        <h2>
          <Icon name="grid" size={16} className="movie-grid-heading-icon" />
          Películas
        </h2>
        {!loading ? (
          <span key={movies.length} className="movie-grid-count-badge">
            {movies.length} {movies.length === 1 ? "resultado" : "resultados"}
          </span>
        ) : null}
      </div>

      {loading ? (
        <div className="movie-grid" aria-hidden="true">
          {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
            <div key={index} className="movie-card-skeleton">
              <div className="movie-card-skeleton-poster" />
              <div className="movie-card-skeleton-line" />
              <div className="movie-card-skeleton-line short" />
            </div>
          ))}
        </div>
      ) : movies.length ? (
        <div className="movie-grid">
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              movie={movie}
              onSelect={onSelect}
              active={selectedMovieId === movie.id}
            />
          ))}
        </div>
      ) : (
        <div className="movie-grid-empty">
          <Icon name="search" size={26} />
          <p>No encontramos resultados</p>
          <span>Probá con otro título o revisá cómo lo escribiste.</span>
        </div>
      )}
    </section>
  );
}
